import React, {useEffect, useMemo} from 'react'
import RedBackground from "../RedBackground";
import RentTypeHeader from "./RentTypeHeader";
import {useLocation} from "react-router-dom";

const HIDE_LOGO_SESSION_KEY = 'front.hideLogo'

const LocationLogoHeader = ({locationInfo, vehicleList}) => {

    const toMinimumRentalMinutes = (minimumRentalTime) => {
        const unit = String(minimumRentalTime?.unit || "").trim().toLowerCase()
        const rawValue = Number(minimumRentalTime?.value)
        const value = Number.isFinite(rawValue) && rawValue > 0 ? rawValue : 1

        if (unit === "hour") return value * 60
        if (unit === "day") return value * 24 * 60
        if (unit === "week") return value * 7 * 24 * 60
        if (unit === "month") return value * 30 * 24 * 60
        return Number.POSITIVE_INFINITY
    }

    const minimumRentalTime = React.useMemo(() => {
        if (!Array.isArray(vehicleList) || vehicleList.length === 0) return null

        let selected = null
        let minMinutes = Number.POSITIVE_INFINITY

        vehicleList.forEach((vehicle) => {
            const minimumRental = vehicle?.rental_config?.minimum_rental_time
            const minutes = toMinimumRentalMinutes(minimumRental)

            if (!Number.isFinite(minutes)) return

            if (minutes < minMinutes) {
                minMinutes = minutes
                selected = {
                    unit: String(minimumRental?.unit || "").trim().toLowerCase(),
                    value: Number(minimumRental?.value) > 0 ? Number(minimumRental?.value) : 1
                }
            }
        })

        return selected
    }, [vehicleList])

    const { pathname, search } = useLocation();

    const hideLogoFromQuery = new URLSearchParams(search).get('hideLogo') === 'true'
    const hideLogoFromSession = typeof window !== 'undefined' &&
        window.sessionStorage &&
        window.sessionStorage.getItem(HIDE_LOGO_SESSION_KEY) === 'true'
    const hideLogo = hideLogoFromQuery || hideLogoFromSession

    useEffect(() => {
        if (hideLogoFromQuery && typeof window !== 'undefined' && window.sessionStorage) {
            window.sessionStorage.setItem(HIDE_LOGO_SESSION_KEY, 'true')
        }
    }, [hideLogoFromQuery])

    const isReservationPage = pathname.startsWith("/reservation")

    if (isReservationPage && !hideLogo) return false;

    console.log("Is reservation = ", isReservationPage)

    if (!locationInfo) return false;
    if (!vehicleList) return false;

    return (
        <RedBackground>
            <div className="container">
                <RentTypeHeader
                    locationInfo={locationInfo}
                    locationId={locationInfo.id}
                    minimumRentalTime={minimumRentalTime}
                />
            </div>
        </RedBackground>
    )
}

export default LocationLogoHeader